module.exports = __webpack_public_path__ + "img/light_desktop.cf47230e.svg";